import { useEstado } from '../../../chat/contexto';
import { CorpoDoPerfil } from './perfil';

/** O perfil da pessoa à direita da DM (D2). */
export function PainelPerfil({ userId }: { userId: string }) {
  const usuario = useEstado((estado) => estado.users[userId]);
  const servidores = useEstado(
    (estado) =>
      estado.guildIds.filter((id) => !!estado.members[id]?.[userId]).length,
  );
  if (!usuario) return null;
  return (
    <aside
      aria-label={`Perfil de ${usuario.global_name ?? usuario.username}`}
      className="rolagem flex w-[340px] shrink-0 flex-col overflow-y-auto border-l border-divisor bg-lateral"
    >
      <CorpoDoPerfil
        usuario={usuario}
        guildId={null}
        fundo="var(--cor-lateral)"
        rodape={
          servidores > 0 ? (
            <p className="m-0 text-sm text-texto-3">
              Servidores em comum: {servidores}
            </p>
          ) : undefined
        }
      />
    </aside>
  );
}
